/* eslint-disable react/no-array-index-key */
import React, { PropsWithChildren } from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import styled from 'styled-components';

import Button from '@src/components/common/button';
import useTranslation from '@src/hooks/useTranslation';
import {
	BUTTON_VARIANT_CONTAINED_DEFAULT_COLOR,
	BUTTON_VARIANT_OUTLINED_DEFAULT_COLOR,
} from '@src/const/common';

const Container = styled.div`
	width: 100%;
	height: calc(var(--vh, 1vh) * 100);
	display: flex;
  justify-content: center;
	padding: 20px;
`;

const Content = styled.div`
	max-width: 400px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
  gap: 20px;
`;

const Text = styled.div`
  width: 100%;
  text-align: center;
`;

const Title = styled.div`
  font-size: 48px;
  font-weight: 500;
  color: #3091FD;
`;

const Message = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #333;
  white-space: pre-line;
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
`;

const StyledButton = styled(Button)`
  flex: 1;
`;

interface ErrorPageProps {
	title: string;
	messages: string[];
}
const ErrorPage = (props: PropsWithChildren<ErrorPageProps>): JSX.Element => {
	const { title, messages, children } = props;
	const { t } = useTranslation();
	const profile = useSelector((state: RootStateOrAny) => state.user.profile);

	const handleOpenEmail = school => {
		const subject = `${school ? `【${school}】` : ''}${t('common:action:report_issue')} | Teaches`;
		const link = `mailto:support@dakastar.com.tw?subject=${subject}`;
		window.open(link);
	};

	return (
		<Container>
			<Content>
				{children}
				<Text>
					<Title>{title}</Title>
					<Message>
						{messages.map((message, index) => (
							<div key={index}>{message}</div>
						))}
					</Message>
				</Text>
				<ButtonContainer>
					<StyledButton
						variant={BUTTON_VARIANT_OUTLINED_DEFAULT_COLOR}
						onClick={() => handleOpenEmail(profile?.school_name)}
					>
						{t('common:action:report_issue')}
					</StyledButton>
					<StyledButton
						variant={BUTTON_VARIANT_CONTAINED_DEFAULT_COLOR}
						onClick={() => {
							window.location.reload();
						}}
					>
						{t('common:action:refresh_page')}
					</StyledButton>
				</ButtonContainer>
			</Content>
		</Container>
	);
};

export default ErrorPage;
